webpackJsonp([75065823977230],{

/***/ 905:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"WeightUnit","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"G"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"KG"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"LB"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"M2"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-weight-unit-b1a0e13dbcedee306ab0.js